module.exports = __webpack_public_path__ + "img/premb-r-pm-mobile-1.3dfaf7a2.svg";